import { render, staticRenderFns } from "./endorsement-extra-benefit-table.vue?vue&type=template&id=ca387562&scoped=true&"
import script from "./endorsement-extra-benefit-table.vue?vue&type=script&lang=js&"
export * from "./endorsement-extra-benefit-table.vue?vue&type=script&lang=js&"
import style0 from "./endorsement-extra-benefit-table.vue?vue&type=style&index=0&id=ca387562&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca387562",
  null
  
)

export default component.exports